import styled from 'styled-components'

import UserAvatar from 'src/components/UserAvatar'

export const ContainerInputJustification = styled.div`
  margin-top: 1.5rem;
`

export const ContainerAvatar = styled.div`
  margin: 1rem 0;
`

export const Avatar = styled(UserAvatar)`
  margin-right: 1rem;
`
